<template>
    <div>
        <app-header>
            <template slot="title">Beteiligung ablehnen</template>
            <template slot="right">
                <router-link to="/neue">
                    <img src="../assets/images/x.svg" alt="close">
                </router-link>
            </template>
        </app-header>
        <div class="container">
            <div id="title">
                <div class="font-title-big">Wieso möchtest du die Beteiligung ablehnen?</div>
                <div class="font-normal">Bitte schreibe Bligg in wenigen Worten eine kurze Begründung:</div>
            </div>
            <form class="form-basic">
                <input type="text" class="font-input">
                <li class="btn-green font-size-btn autofocus" @click.prevent="submitted"
                        @click="setModalFeedback(true)">
                    <router-link to="/trends">
                        Absenden
                    </router-link>
                </li>
            </form>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import modals from '../data/modals'

  export default {
    components: {
      appHeader: Header
    },
    methods: {
      submitted(e) {
        e.preventDefault();
      },
      setModalFeedback(val) {
        modals.feedback = val;
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import './../styles/app';

    .container {
        padding: 20px;
        height: 100%;
        form {
            position: relative;
            height: 100%;
            li {
                list-style: none;
                text-align: center;
                position: fixed;
                width: calc(100% - 40px);
                border-radius: 6px;
                margin: 0;
                bottom: 10px;
                left: 20px;
                a{
                    padding: 14px;
                }
            }
        }
    }

</style>
